<div class="add-tools-pop-up">
  <div class="baloon-add-tools">
    <div class="add-tools-container pt-1 px-3" [ngClass]="{'market-data': showOnlyMarketData}">
      <div class="w-100 mb-1 box-search">
        <mat-form-field class="w-100">
          <mat-label>Pesquisar ferramenta</mat-label>
          <input id="filter-tool-name" (keyup)="filterComponent($event)" autocomplete="off" matInput type="text"
            [(ngModel)]="value">
          <mat-icon matSuffix svgIcon="search"></mat-icon>
        </mat-form-field>
      </div>
      <div *ngIf="!showSearch">
        <div *ngFor="let title of listCard">
          <div *ngIf="title.list.length">
            <span class="title-text">{{title.title}}</span>
            <div class="add-tools-body">
              <div class="justify-content-between p-1 pb-0 row">
                <div *ngFor="let item of title.list"
                  class="p-0 col-5 button-tools d-flex justify-content-center align-items-center mb-2">
                  <span class="text-button-tools" id="span-{{item.id}}">{{item.title}}</span>
                  <div class="button-tools-circle" (click)="addItemWorkspace(item)" id="add-item-{{item.id}}">
                    <div class="icon-add-circle pointer">
                      <mat-icon svgIcon="add"></mat-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="showSearch" class="add-tools-body">
        <div class="justify-content-between p-1 row">
          <div *ngFor="let item of filteredSearch"
            class="p-0 col-5 button-tools d-flex justify-content-center align-items-center mb-2">
            <span class="text-button-tools" id="span-{{item.id}}">{{item.title}}</span>
            <div class="button-tools-circle" (click)="addItemWorkspace(item)" id="add-item-{{item.id}}">
              <div class="icon-add-circle pointer">
                <mat-icon svgIcon="add"></mat-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
